import { PipeTransform } from "@angular/core";

export function encadearPipes(pipes: PipeTransform[]): PipeTransform {
  return {
    transform: (value: string) => {
      let result = value;

      pipes.forEach(pipe => {
        result = pipe.transform(result);
      });

      return result;
    }
  } as PipeTransform;
}
